import _ from "lodash"

const checkIsUniqUpTo = (array, message = 'Up to unique values is required') => {
  if (_.isArray(array)) {
    const isUniqUpTo = _.uniqBy(array, 'up_to').length === array?.length;
    return isUniqUpTo ? '' : message;
  }
}

export default checkIsUniqUpTo;